<template>
  <div>
    <titleAgency/>
    <filterAgency/>
    <tableAgency class="px-5" />
  </div>
</template>

<script>
import titleAgency from '@/components/_managerole/_overview/title.vue'
import filterAgency from '@/components/_managerole/_overview/filter.vue'
import tableAgency from '@/components/_managerole/_overview/table.vue'
export default {
  components: {
    titleAgency,
    filterAgency,
    tableAgency
  }
}
</script>

<style scoped>
</style>
